export default __webpack_public_path__ + "static/media/js.9c28cb94.svg";